/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

// THIS FILE IS GENERATED BY BUILD TOOL
// DO NOT EDIT IT MANUAL
import { wrapIcon } from '../../wrapIcon';
import { SVGProps } from 'react';
const SvgCellClickBase = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2 16.2655V3.15667M2 16.2655C2 16.9044 2.51659 17.4222 3.15385 17.4222H11.8462M2 16.2655V14.7233C2 14.0845 2.51659 13.5667 3.15385 13.5667M2 3.15667C2 2.51786 2.51659 2 3.15385 2H20.8462C21.4834 2 22 2.51786 22 3.15667V4.69889C22 5.3377 21.4834 5.85555 20.8462 5.85555M2 3.15667V4.69889C2 5.3377 2.51659 5.85555 3.15385 5.85555M3.15385 5.85555H20.8462M3.15385 5.85555H10.8462M3.15385 5.85555C2.51659 5.85555 2 6.37341 2 7.01222V8.55444C2 9.19325 2.51659 9.71111 3.15385 9.71111M20.8462 5.85555H13.1538M20.8462 5.85555C21.4834 5.85555 22 6.37341 22 7.01222V11.2533M3.15385 9.71111H13.6923M3.15385 9.71111C2.51659 9.71111 2 10.229 2 10.8678V12.41C2 13.0488 2.51659 13.5667 3.15385 13.5667M3.15385 13.5667H11.8462M19.9432 22L18.8282 17.8289M18.8282 17.8289L16.7692 19.6593L17.2356 11.8702L21.5246 18.382L18.8282 17.8289Z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const SvgCellClick = wrapIcon(SvgCellClickBase);
export default SvgCellClick;
